module.exports = __webpack_public_path__ + "img/mobile2.be83f892.png";